import { useEffect, useState } from "react";
import Header from "./Header";
import Webcam from "react-webcam";
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';

import axios from 'axios';

function AiTest() {
    const videoConstraints = {
        width: 1280,
        height: 720,
        facingMode: "user"
    };

    const [res, setRes] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    return (
        <div>
            <Header />
            <div className="standard-box3">
                <h3>
                    Test our AI
                </h3>
            </div>
            <div
                align='center'
                className="standard-box3"
            >
                <div
                    style={{ display: 'flex' }}
                >
                    <div>
                        <Webcam
                            audio={false}
                            height={600}
                            screenshotFormat="image/jpeg"
                            width={800}
                            videoConstraints={videoConstraints}
                            style={{ borderRadius: '0.2em', padding: '0.2em', backgroundColor: 'black' }}
                        >
                            {({ getScreenshot }) => (
                                <div align='center'>
                                    <Button
                                        label='Detect'
                                        severity='success'
                                        onClick={() => {
                                            setIsLoading(true);
                                            const imageSrc = getScreenshot()
                                            console.log(imageSrc);
                                            axios.post(
                                                process.env.REACT_APP_API_HOST + '/ai/test/',
                                                {
                                                    image: imageSrc
                                                }
                                            ).then(
                                                (response) => {
                                                    console.log(response.data[0]);
                                                    setRes(response.data);
                                                    setIsLoading(false);
                                                }
                                            ).catch(
                                                (error) => {
                                                    setIsLoading(false);
                                                }
                                            )
                                        }}
                                    >
                                    </Button>
                                </div>
                            )}
                        </Webcam>
                    </div>
                    <div style={{ marginLeft: '2em' }}>
                        <h3>
                            Sentiment Analysis:
                        </h3>
                        <div>
                            {
                                !res && !isLoading &&
                                <div>
                                    Click "Detect"
                                </div>
                            }
                            {
                                isLoading &&
                                <ProgressSpinner />
                            }
                            {
                                res &&
                                <div>
                                    {/* {JSON.stringify(res[0])} */}
                                    <div>
                                        Dominant emotion:
                                        <h3>
                                            {res[0].dominant_emotion}
                                        </h3>
                                    </div>
                                    <div>
                                        Details:
                                        <div><pre>{JSON.stringify(res[0], null, 2)}</pre></div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}

export default AiTest;